/**
 * @generated SignedSource<<ab21a5aeeb876a1894b0c9399a9b5d87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MusicPageStatus = "ERROR" | "UPLOADED" | "UPLOADING" | "%future added value";
export type MusicUpdatePageInput = {
  page_id: string;
  status: MusicPageStatus;
};
export type UpdateMusicPageMutation$variables = {
  input: MusicUpdatePageInput;
};
export type UpdateMusicPageMutation$data = {
  readonly music_update_page: {
    readonly page_id: string;
  };
};
export type UpdateMusicPageMutation = {
  variables: UpdateMusicPageMutation$variables;
  response: UpdateMusicPageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MusicPageOutput",
    "kind": "LinkedField",
    "name": "music_update_page",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "page_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateMusicPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateMusicPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5cfb4953f23c1211646b5bf8b4f50e14",
    "id": null,
    "metadata": {},
    "name": "UpdateMusicPageMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateMusicPageMutation(\n  $input: MusicUpdatePageInput!\n) {\n  music_update_page(input: $input) {\n    page_id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3bfb6408abeab63e5e48d8b7f7f31d79";

export default node;
